import { MaterialSelect, type PolozkaCennika } from "@/components/slot/MaterialSelect";
import type { Material } from "@/api/schemas";

/**
 * Výber kovania — od KOLA 202 tá istá tabuľka ako materiál a hrana
 * (`MaterialSelect`, jedno okno KOLA 201), len so sekciou Kovanie:
 *
 * - **★ Obľúbené zapnuté** pri otvorení — kurátorský výber zo stránky
 *   Kovania (predtým kapsula „Všetky obľúbené"); vypnuté = celé kovanie
 *   (predtým fajka „všetky v kategórii"),
 * - **Kategória ▾** so skupinami a počtami (Závesy — všetko, Závesy
 *   s tlmením…) namiesto radu kapsúl, s hľadaním a ✕,
 * - **pri písaní** kategória ostane a obľúbené sa vypnú — hľadá sa v celom
 *   kovaní kategórie (user, KOLO 202); predtým hľadanie ignorovalo oboje,
 * - **Aj iní dodávatelia** — inak výrobok značky len od preferovaného
 *   dodávateľa (Blum → TWD, KOLO 166),
 * - alias hore, pravý názov pod ním (KOLO 176), Set, výpredaj, „Načítať
 *   ďalšie" namiesto stropu 20/50.
 *
 * Rovnaká onChange signatúra ako MaterialSelect.
 */
export function KovanieCategoryPicker({
  value,
  onChange,
  onPotvrd,
  vOkne = false,
  kompaktny = false,
  pociatocnaKategoria,
  vynechat,
  pripraveny,
}: {
  value: string | null;
  onChange: (id: string | null, material?: Material) => void;
  /** Dvojklik / Enter — okno s vlastným tlačidlom (`VyberKovaniaDialog`). */
  onPotvrd?: (material: PolozkaCennika) => void;
  vOkne?: boolean;
  kompaktny?: boolean;
  /** Korpus Builder otvorí Nohy či Výsuvy, výmena kategóriu starého. */
  pociatocnaKategoria?: string;
  /** Kovanie, ktoré sa práve mení — ponúkať ho nemá zmysel. */
  vynechat?: readonly string[];
  pripraveny?: boolean;
}): JSX.Element {
  return (
    <MaterialSelect
      value={value}
      onChange={onChange}
      onPotvrd={onPotvrd}
      sekcia="kovanie"
      oblubenePredvolene
      pociatocnaKategoria={pociatocnaKategoria}
      vynechat={vynechat}
      vOkne={vOkne}
      kompaktny={kompaktny}
      pripraveny={pripraveny}
      placeholder="Vyhľadať kovanie (názov, kód, dekor)…"
      autoFocus={!vOkne}
    />
  );
}
